export default {
    install: function (Vue) {
      Object.defineProperty(Vue.prototype, '$bus', { value: new Vue() })
    }
  }
  